<template>
  <div>
    <b-row>
      <b-col>
        <div class="row">
          <div class="col-md-6 my-auto">
            <h4 class="m-0">Users List</h4>
          </div>
          <div class="col-md-6 text-right">
            <b-button :to="{name: 'users-create'}"  variant="primary">
              <i class="lni lni-circle-plus"></i> Create
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <div class="card grmt-7 grmb-7" no-body>
      <b-row class="mx-1 mt-3">
        <b-col>
          <div>
            <div id="displayOptions">
              <div class="d-block">
                <div class="d-inline-block float-md-left mr-1 align-top mb-1">
                  <label class="form-group mb-4">
                    <b-form-input
                      type="text"
                      class="form-control data-search-form-control"
                      v-model="search"
                      placeholder="search..."
                    />
                  </label>
                </div>
              </div>

              <div class="float-md-right">
                <b-dropdown
                  id="ddown1"
                  :text="sort.label"
                  variant="light"
                  class="mr-2 d-inline-block float-md-left btn-group"
                  menu-class="bg-white"
                >
                  <b-dropdown-item
                    v-for="(order, index) in sortOptions"
                    :key="index"
                    @click="changeOrderBy(order)"
                  >{{ order.label }}</b-dropdown-item>
                </b-dropdown>

                <b-dropdown
                  id="ddown2"
                  right
                  :text="`${rowsPerPage}`"
                  variant="light"
                  menu-class="bg-white"
                  class="d-inline-block"
                >
                  <b-dropdown-item
                    v-for="(size, index) in pageSizes"
                    :key="index"
                    @click="changePageSize(size)"
                  >{{ size }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
          <div style="clear:both;"></div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div v-if="isLoad" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>

          <div v-if="!isLoad">
            
            <div class="card bg-light text-black-50 no-border no-shadow no-round">
              <div class="card-body px-3 py-3 font-weight-bold">
                <div class="row no-gutters">
                  <div class="col-md-3">Name</div>

                  <div class="col-md-4">Email</div>

                  <div class="col-md-3">Roles</div>

                  <div class="col-md-2 text-left text-md-right">Action</div>
                </div>
              </div>
            </div>

            <div v-for="item in items" :key="item.id">
              <div class="bg-white border-bottom p-3">
                <div class="row no-gutters">
                  <div class="col-md-3">
                    <p class="m-0 font-weight-600">{{ item.name }}</p>
                  </div>

                  <div class="col-md-4">
                    <p class="m-0">{{ item.email }}</p>
                  </div>

                  <div class="col-md-3">
                    <b-badge
                      class="mb-1 mr-1"
                      variant="light"
                      v-for="role in item.roles"
                      :key="role.id"
                    >{{ role.name }}</b-badge>
                  </div>

                  <div class="col-md-2 my-auto text-left text-md-right pt-3 pt-md-0">
                    <router-link
                      v-b-tooltip.hover
                      title="view"
                      :to="{name: 'users-show',params: { id: item.id }}"
                      class="text-info"
                    >
                      <i class="lni lni-search-alt grmr-7"></i>
                    </router-link>

                    <router-link
                      v-b-tooltip.hover
                      title="Edit"
                      :to="{name: 'users-edit',params: { id: item.id }}"
                      class="text-primary"
                    >
                      <i class="lni lni-pencil-alt grmr-7"></i>
                    </router-link>

                    <span
                      v-b-tooltip.hover
                      style="cursor:pointer"
                      title="Delete"
                      @click="confirmDelete(item.id)"
                      class="text-danger"
                    >
                      <i class="lni lni-trash"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="my-3 mx-1">
        <b-col md="6" class="text-center text-md-left" v-if="lastPage > 1">
          <b-pagination
            @change="page  = $event;  getUsers()"
            v-model="page"
            :total-rows="totalRows"
            :per-page="rowsPerPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
        <b-col md="6 text-center text-md-right pt-2">
          <span
            class="text-black-50 font-size-13"
          >Showing {{ fromRow }} to {{ toRow }} of {{ totalRows }}</span>
        </b-col>
      </b-row>
    </div>

    <b-sidebar 
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'users' })" 
      :lazy="true" 
      id="sidebar" 
      backdrop shadow>
      <div class="px-3 py-2">
        <router-view @userCreated="userCreated()" @userUpdated="userUpdated()"></router-view>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import userRepo from "@/api/repos/userRepo";

export default {
  components: {},

  data() {
    return {
      sidebarToggle:false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" }
      ],
      delayTimer: null,
      page: 1,
      rowsPerPage: 10,
      search: "",
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
      pageSizes: [5, 10, 25, 100],
    };
  },
  mounted() {
    this.getUsers();  
  },
  methods: {
    async deleteUser(id) {
      this.isBusy = true;
      try {
        await userRepo.delete(id);
        this.items = this.items.filter(item => item.id !== id);
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the user.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(confirm => (confirm ? this.deleteUser(id) : false))
        .catch(error => console.log(error));
    },
    async getUsers() {
      this.isLoad = true;
      try {
        let { data } = await userRepo.users(
          this.page,
          this.rowsPerPage,
          this.sort.column,
          this.sort.order,
          this.search
        );

        this.items = data.users.data;
        this.totalRows = data.users.total;
        this.page = data.users.current_page;
        this.fromRow = data.users.from;
        this.toRow = data.users.to;
        this.lastPage = data.users.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    
    userCreated() {
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc"
      };
      this.page = 1
      this.sidebarToggle=false
      this.getUsers()      
    },

    userUpdated() {
      this.sidebarToggle=false
      this.getUsers()      
    },

    changePageSize(perPage) {
      this.rowsPerPage = perPage;
      this.getUsers();
    },
    changeOrderBy(sort) {
      this.sort = sort;
      this.getUsers();
    },
    searchQuery() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        this.page = 1;
        this.getUsers();
      }, 750);
    }
  },

  watch: {
    search() {
      this.searchQuery();
    },
    $route: {
      immediate: true,
      handler: function(newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;           
      }
    }
  }
};
</script>
